export default __webpack_public_path__ + "static/hp-brand-deck-02-f697b515015d8250370ab379babf6a45.png";